import { z } from "zod";
import { countryCodes } from "@/features/profile/constants/country-codes";

export const phoneOtpSchema = z
  .string()
  .trim()
  .min(6, "Enter a valid phone number")
  .regex(/^\+?[0-9]+$/, "Phone number should contain digits only")
  .refine((phone) => {
    const cleanPhone = phone.replace(/^\+/, "");

    return countryCodes.some((country) => {
      const cleanCode = country.dialCode.replace(/^\+/, "");
      return cleanPhone.startsWith(cleanCode);
    });
  }, "Enter a valid phone number with a country code");
